import Vue from 'vue'
import router from '@/router'
import VStore from '@/packages/vstore'
import { parseRoles } from '@/utils/role'
import { getAccount } from '@/views/admin/main/mainServer'
import { User } from '@/views/admin/main/model/User'
import { letterCount } from '@/views/user/letter/service/letter'
import homeAxios from '@/views/user/index/homeService'

let cacheSkin = JSON.parse(localStorage.getItem('skin'))

// 全局状态数据
const store = {
  state: {
    // 当前是否用户端页面
    isUserPage: true,

    userInfo: {},

    userRoles: {},
    packageData: {}, //保存套餐数据
    //消息个数统计
    letterCount: {
      myNoticeCount: 0, //全部消息
      // pendingNoticeCount: 0, //未读消息
      readNoticeCount: 0, //已读消息（自定义字段为了实现页面效果）
      pressNoticeCount: 0 //催办消息
    },
    frameworkId: '',
    pageGuides: {}, //新手引导数据
    skin: cacheSkin || {}, //换肤数据
    uuid: '', //手写签名uuid参数
    logoRandom: {
      user: Date.now(), //个人logo
      company: Date.now() //企业logo
    } //用于logo刷新
  },

  mutations: {
    // 设置用户信息
    setUser(state, userInfo) {
      let { userMenu: roles } = (state.userInfo = userInfo || {})
      state.userRoles = parseRoles(roles)
    },

    // 更新当前是否用户端页面
    checkUserPage(state, isUserPage) {
      state.isUserPage = isUserPage
    },

    /**
     * 提交消息统计信息
     * @param state 状态树
     * @param letterCountObject 消息统计信息数据
     */
    commitLetterCount(state, letterCountObject) {
      for (let i in letterCountObject) {
        if (state.letterCount.hasOwnProperty(i)) {
          state.letterCount[i] = parseInt(letterCountObject[i])
        }
      }
    },

    /**
     * 消息统计数量减少
     * @param state 状态树
     * @param letterCountObject 消息统计信息数据
     */
    decrementLetter(state, letterCountObject) {
      for (let i in letterCountObject) {
        if (state.letterCount.hasOwnProperty(i) && state.letterCount[i] - letterCountObject[i] >= 0) {
          //减少相应的消息类型的个数
          state.letterCount[i] -= letterCountObject[i]
        }
      }
    },
    /**
     * 消息统计数量增加
     * @param state 状态树
     * @param letterCountObject 消息统计信息数据
     */
    incrementLetter(state, letterCountObject) {
      for (let i in letterCountObject) {
        if (state.letterCount.hasOwnProperty(i)) {
          //增加相应的消息类型的个数
          state.letterCount[i] += letterCountObject[i]
        }
      }
    },
    //树形结构选中状态赋值
    selectFrameworkId(state, value) {
      state.frameworkId = value
    },
    /**
     * 设置新手引导数据
     * @param state
     * @param page
     * @param flag
     * @param order
     */
    setPageGuide(state, page, { flag, order }) {
      if (!state.pageGuides[page]) {
        Vue.prototype.$set(state.pageGuides, page, {
          instance: {},
          queue: [],
          index: 0
        })
      }
      state.pageGuides[page].instance[flag] = order
      state.pageGuides[page].queue = Object.entries(state.pageGuides[page].instance)
        .map(([flag, order]) => ({ flag, order }))
        .sort((a, b) => a.order - b.order)
    },
    /**
     * 设置换肤数据
     * @param state
     * @param skin
     */
    setSkin(state, skin) {
      state.skin = skin
    },
    /**
     * 设置uuid
     * @param state
     * @param uuid
     */
    setUuid(state, uuid) {
      state.uuid = uuid
    },
    /**
     * 设置logo刷新
     * @param state
     * @param user 个人
     * @param company 企业
     */
    setLogoRandom(state, { user = 0, company = 0 }) {
      state.logoRandom.user = user
      state.logoRandom.company = company
    },
    /**
     * 设置套餐详情数据
     */
    setPackageData(state, packageData) {
      state.packageData = packageData
    }
  },

  actions: {
    /**
     * 提交消息统计信息
     * @param context
     */
    async commitLetterCount(context) {
      const { success, data } = await letterCount()

      if (success) {
        context.commit('commitLetterCount', data)
      }
    },
    /**
     * 消息统计数量减少
     * @param context
     * @param letterCountObject 消息统计信息数据
     */
    decrementLetter(context, letterCountObject) {
      context.commit('decrementLetter', letterCountObject)
    },
    /**
     * 消息统计数量增加
     * @param context
     * @param letterCountObject 消息统计信息数据
     */
    incrementLetter(context, letterCountObject) {
      context.commit('incrementLetter', letterCountObject)
    },
    /**
     * 获取用户信息
     * @param context
     * @returns {Promise<void>}
     */
    async setUser(context) {
      const { success, message, data } = await getAccount()

      if (success) {
        const userInfo = new User(data)
        localStorage.setItem('fdd-user-info', JSON.stringify(data))

        context.commit('setUser', userInfo)

        if (!localStorage.getItem('TOKEN')) {
          localStorage.setItem('TOKEN', data.authToken) // todo 这里是undefined
        }
      } else {
        Vue.prototype.$error(message)
        throw new Error(message)
      }
    },
    async checkOpenId({ commit }, params) {
      const res = await homeAxios.checkOpenId(params)
      const { success, message, data } = res
      if (success) {
        sessionStorage.setItem('authToken', data.authToken)
        sessionStorage.setItem('token', data.authToken) // token是前端登陆态
        localStorage.setItem('isLogin', true)
        sessionStorage.setItem('OPENID', data.openId)
        sessionStorage.setItem('corpId', data.openId.split('_')[0])
        localStorage.setItem('isBindAccount', data.isBindAccount)
        localStorage.setItem('checkOpenIdInfo', JSON.stringify(data))
      } else {
        Vue.prototype.$error(message)
        router.push('/login')
        throw new Error(message)
      }
    }
  }
}

const $store = new VStore(store)

// 全局状态
Vue.use(VStore, $store)

export default $store
